<script>
  export let data = {
    name: "Time",
    value: 0,
    size: "col-12 col-md-4",
    style: "small-box bg-secundary",
    icon: "ion ion-ios-clock",
  };


</script>

<div class={data.size}>
  <!-- small box -->
  <div class={data.style}>
    <div class="inner">
      <h3>{data.value}</h3>
      <p>{data.name}</p>
    </div>
    <div class="icon">
      <i class={data.icon} />
    </div>
  </div>
</div>
